import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import ExportAnnouncementEmployeeDataApiServiceResponse from "../model/ExportAnnouncementEmployeeDataApiServiceResponse";

const ExportAnnouncementEmployeeDataApiService = async (
  request: number
): Promise<ExportAnnouncementEmployeeDataApiServiceResponse> => {
  const url = `/announcements/${request}/exportannouncementemployeedata/`;
  const { data, headers } = await axios.get(url);
  return {
    data,
    filename: headers["content-disposition"].split('filename="')[1],
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useExportAnnouncementEmployeeDataApiService = () =>
  useMutation<
    ExportAnnouncementEmployeeDataApiServiceResponse,
    AxiosError,
    number
  >(ExportAnnouncementEmployeeDataApiService, {
    mutationKey: "ExportAnnouncementEmployeeDataApiService",
  });
export default useExportAnnouncementEmployeeDataApiService;
